import { render, staticRenderFns } from "./tenant-calendar.vue?vue&type=template&id=236ff18d&scoped=true&"
import script from "./tenant-calendar.vue?vue&type=script&lang=js&"
export * from "./tenant-calendar.vue?vue&type=script&lang=js&"
import style0 from "./tenant-calendar.vue?vue&type=style&index=0&id=236ff18d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236ff18d",
  null
  
)

export default component.exports